import { Reducer } from 'redux';

import { ActionTypes } from '../types/action-types';
import { ActionObject, IAuth } from '../types/auth';

export default ((state = {
  apikey: ''
}, action: ActionObject): IAuth => {
  switch (action.type) {
    case ActionTypes.HB_KEY_UPDATED:
      return {
        apikey: action.apikey,
      };
  }
  return {...state};
}) as Reducer<IAuth>;



// WEBPACK FOOTER //
// ./src/sub-projects/hubspot/reducers/auth.ts